module.exports = __webpack_public_path__ + "media/images/spree/frontend/icons/close-535d18aec640c0f11e27fc7ac236ee97.png";